module.exports = __webpack_public_path__ + "30046fa228ac404360f0cbf037849c30.pdf";